<template>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title class="headline">
          Wyślij Email
        </v-card-title>
        <v-card-text>
          <v-form
              ref="newForm"
              lazy-validation
              class="dimension--form mt-5 mb-5"
          >
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-autocomplete
                    v-model="sendEmailUser"
                    :items="users"
                    item-value="id"
                    item-text="email"
                    label="Użytkownik"
                >
                </v-autocomplete>
                <SendEmail
                    :receiver-entity-id="sendEmailUser"
                    receiver-entity-name="User"
                    :disabled=!sendEmailUser
                    :templates-to-list="[
                                    'account-activation-documents-details-mismatch',
                                    'account-activation-documents-unreadable',
                                    'account-activation-email-mismatch',
                                    'account-activation-no-transfer',
                                    'account-activation-transfer-details-mismatch',
                                    'account-activation-waiting',
                                    'account-premium-activation-confirmed',
                                    'company-details-updated',
                                    'transfer-refund',
                                    'emitter-add-new-sale-offer',
                                    'natural-person-add-new-sale-offer',
                                    'natural-person-waste-algorithm',
                                    'collector-buy-with-waste-master',
                                    'collector-add-sale-offer',
                                  ]"
                ></SendEmail>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>

import api from "@/services/api";
import SendEmail from "@/components/SendEmail.vue";

export default {
  name: 'ModalSendEmail',
  components: {SendEmail},
  mixins: [
  ],
  created() {
  },
  data: () => ({
    dialog: false,
    sendEmailUser: null,
    users: [],
    id: null,
  }),
  methods: {
    open(id) {
      this.id = id;
      this.dialog = true;
      this.getUsers();
    },
    getUsers() {
      api.get(`/api/companies/${this.id}/users`, {})
          .then((response) => {
            this.users = response.data.items;
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się wczytać danych użytkowników.',
              error,
            });
          });
    },
  },
}
</script>

<style scoped></style>
